import { PLAN_TYPE } from '@/const/plans';

import { fetchCheckoutSession } from '../utils';

export function useCheckoutPreload(plans = []) {
	async function preloadSession(planName = PLAN_TYPE.TRIAL) {
		if (plans?.length) {
			const defaultPlan = plans.find(
				item => item.name === planName && item.active
			);

			// Preload checkout session promise
			window.createCheckoutSessionPromise = fetchCheckoutSession({
				priceId: defaultPlan?.handlerId,
				currency: defaultPlan.currency
			});
		}
	}

	return {
		preloadSession,
		clearCachedSession: () => {
			window.createCheckoutSessionPromise = null;
		}
	};
}
